export default {
  DotcomHeaderMobile__BUTTON_GROUP_ARIA_NEXT: "Next",
  DotcomHeaderMobile__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
  DotcomHeaderMobile__HOME_LOGO_ARIA: "Southwest home",
  DotcomHeaderMobile__LOGOUT: "Log out",
  DotcomHeaderMobile__MENU_ARIA: "Menu",
};
